// Кнопка «зберегти питання у закладки». Toggle-семантика: клік перемикає стан.
// При першому рендері запитує API чи питання вже в закладках. Оптимістично оновлює UI.

import { useEffect, useState } from 'react';
import { api } from '../lib/api';
import { haptic } from '../lib/telegram';

export function BookmarkButton({ questionId }: { questionId: number }) {
  const [bookmarked, setBookmarked] = useState<boolean | null>(null); // null = ще не знаємо
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    let cancelled = false;
    api.checkBookmark(questionId)
      .then((r) => !cancelled && setBookmarked(r.bookmarked))
      .catch(() => !cancelled && setBookmarked(false));
    return () => { cancelled = true; };
  }, [questionId]);

  async function toggle() {
    if (busy) return;
    setBusy(true);
    // Оптимістичний апдейт — миттєвий feedback
    setBookmarked((b) => !b);
    haptic.light();
    try {
      const r = await api.toggleBookmark(questionId);
      setBookmarked(r.bookmarked);
    } catch {
      // Помилка — повертаємо назад
      setBookmarked((b) => !b);
      haptic.error();
    } finally {
      setBusy(false);
    }
  }

  return (
    <button
      onClick={toggle}
      disabled={busy || bookmarked === null}
      className={`grid h-9 w-9 shrink-0 place-items-center rounded-full bg-tg-secondary-bg transition active:scale-90 disabled:opacity-50 ${
        bookmarked ? 'text-tg-success' : 'text-tg-hint'
      }`}
      title={bookmarked ? 'Прибрати із закладок' : 'Зберегти'}
    >
      {/* Серце: збережено = залите, ні = контур */}
      <svg
        viewBox="0 0 24 24"
        className="h-5 w-5"
        fill={bookmarked ? 'currentColor' : 'none'}
        stroke="currentColor"
        strokeWidth={1.8}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M12 19.5s-6.8-4.1-8.4-8A4.6 4.6 0 0 1 12 7.6a4.6 4.6 0 0 1 8.4 3.8c-1.6 4-8.4 8.1-8.4 8.1Z" />
      </svg>
    </button>
  );
}
